import { useMediaQuery } from '@mui/material'
import { breakpoints } from '../../../../apps/mpv3/src/theme/breakpoints'

interface IUseDevices {
  isTabletSize: boolean
  isDesktop: boolean
  isMobileLarge: boolean
}

/**
 * Hook used to find the current device.
 * @returns Object with different device related values.
 */
export const useDevices = (): IUseDevices => {
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.laptop}px)`)
  const isTabletSize = useMediaQuery(
    `(max-width: ${breakpoints.tablet}px) and (min-width: ${breakpoints.mobileXLarge}px)`
  )

  const isMobileLarge = useMediaQuery(
    `(max-width: ${breakpoints.mobileLarge}px)`
  )

  return { isTabletSize, isDesktop, isMobileLarge }
}
